module.exports = __webpack_public_path__ + "img/account-home-icon.e92d43d1.svg";